import { render } from "./FooTer.vue?vue&type=template&id=80b50ba6&scoped=true"
const script = {}

import "./FooTer.vue?vue&type=style&index=0&id=80b50ba6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b50ba6"]])

export default __exports__